/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Options from './Options/index'
import React from 'react'
import Type from './Type/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Questions/Content/Editor/Content/EditArea/QuestionFields/Content/AdditionalFields/Content"
  
}) {
  return (<React.Fragment
>
<Type
  viewPath={`${viewPath}/Type`}
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
{children}
</React.Fragment>)
}